@let state = fieldRef(); @if (state().touched() && state().errors().length) {
<ul data-testid="field-error-list" class="error-list">
  @for (error of state().errors(); track $index) {
  <li>{{ error.message | translate}}</li>
  }
</ul>
}
